import { useController, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { TagPickerProps } from "./TagPicker.types";
import * as yup from "yup";

const tagsValidationSchema = yup.object().shape({
  newTag: yup
    .string()
    .trim()
    .min(1, "Min tag length 1")
    .required("Tag name is required"),
});

export const useTagPicker = ({ control }: TagPickerProps) => {
  const {
    control: newTagControl,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: {
      newTag: "",
    },
    resolver: yupResolver(tagsValidationSchema),
  });

  const {
    field: { value: tags, onChange },
    fieldState: { error },
  } = useController({
    name: "tags",
    control,
  });

  const newTagError = error?.message;

  const onAddNewTagClick = handleSubmit(({ newTag }) => {
    if (tags?.includes(newTag)) {
      return;
    }

    onChange([...tags, newTag]);
    reset();
  });

  const onRemoveTagClick = (tag: string) => {
    const notRemovedTags = tags?.filter(
      (currentTag: string) => currentTag !== tag
    );

    onChange(notRemovedTags);
  };

  return {
    tags,
    newTagControl,
    newTagError,
    onAddNewTagClick,
    onRemoveTagClick,
  } as const;
};
